import { render, staticRenderFns } from "./ability.vue?vue&type=template&id=f96e614c&scoped=true&"
import script from "./ability.vue?vue&type=script&lang=js&"
export * from "./ability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96e614c",
  null
  
)

export default component.exports